import { Toaster as HotToaster } from 'react-hot-toast';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * アプリ全体の通知基盤コンポーネント
 * react-hot-toast（簡易通知）と Sonner（確認ダイアログ）を管理
 */
export const AppToaster = () => {
  return (
    <>
      {/* 1. 簡易通知用 (react-hot-toast) */}
      <HotToaster />

      {/* 2. 確認ダイアログ用 (Sonner) */}
      <SonnerToaster 
        position="top-center" 
        // デザインは useAppDialog 側で完結させるため、
        // ここでは重なり順（zIndex）のみを確実に保証
        toastOptions={{
          style: { 
            zIndex: 99999,
            width: '500px',
            maxWidth: 'calc(100vw - 2rem)', // スマホで見切れるのを防ぐ
          },
        }}
      />
    </>
  );
};